import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "./client";

export interface BugReport {
  id: string;
  title: string;
  category: string;
  description: string;
  systemInfo: {
    userAgent: string;
    viewport: string;
    appVersion: string;
    currentPage: string;
  } | null;
  status: string;
  userId: string | null;
  user?: { id: string; name: string; email: string } | null;
  createdAt: string;
  updatedAt: string;
}

interface CreateBugReportPayload {
  title: string;
  category: string;
  description: string;
  systemInfo?: {
    userAgent: string;
    viewport: string;
    appVersion: string;
    currentPage: string;
  };
}

export function useSubmitBugReport() {
  return useMutation({
    mutationFn: (payload: CreateBugReportPayload) =>
      apiFetch<{ id: string; message: string }>("/feedback", {
        method: "POST",
        body: JSON.stringify(payload),
      }),
  });
}

export function useBugReports(status?: string) {
  return useQuery<BugReport[]>({
    queryKey: ["bug-reports", status],
    queryFn: () => {
      const params = status ? `?status=${status}` : "";
      return apiFetch<BugReport[]>(`/feedback${params}`);
    },
  });
}

export function useUpdateBugReportStatus() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }: { id: string; status: string }) =>
      apiFetch<BugReport>(`/feedback/${id}`, {
        method: "PATCH",
        body: JSON.stringify({ status }),
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["bug-reports"] });
    },
  });
}
